// Generated by purs version 0.15.15
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Data_StreamEvent from "../MST.Data.StreamEvent/index.js";
import * as MST_Data_Units from "../MST.Data.Units/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var LocalIsSymbol = {
    reflectSymbol: function () {
        return "Local";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(urlIsSymbol)(MST_Data_BasicURL.showBasicURL);
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(showRecordFieldsConsNil)));
var RemoteIsSymbol = {
    reflectSymbol: function () {
        return "Remote";
    }
};
var batchIsSymbol = {
    reflectSymbol: function () {
        return "batch";
    }
};
var NetworkReportIsSymbol = {
    reflectSymbol: function () {
        return "NetworkReport";
    }
};
var errorIsSymbol = {
    reflectSymbol: function () {
        return "error";
    }
};
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(errorIsSymbol);
var ErrorIsSymbol = {
    reflectSymbol: function () {
        return "Error";
    }
};
var OkIsSymbol = {
    reflectSymbol: function () {
        return "Ok";
    }
};
var commandIsSymbol = {
    reflectSymbol: function () {
        return "command";
    }
};
var BadCommandIsSymbol = {
    reflectSymbol: function () {
        return "BadCommand";
    }
};
var ConnectionEstablishedIsSymbol = {
    reflectSymbol: function () {
        return "ConnectionEstablished";
    }
};
var streamIdIsSymbol = {
    reflectSymbol: function () {
        return "streamId";
    }
};
var showRecordFieldsConsNil2 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(streamIdIsSymbol)(MST_Data_Units.showStreamId);
var genericShowConstructor2 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(showRecordFieldsConsNil2)));
var StreamNotFoundIsSymbol = {
    reflectSymbol: function () {
        return "StreamNotFound";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(streamIdIsSymbol)(showRecordFieldsConsNil)(MST_Data_Units.showStreamId);
var StartedDownloadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartedDownloadStream";
    }
};
var byteCountIsSymbol = {
    reflectSymbol: function () {
        return "byteCount";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(byteCountIsSymbol);
var StartedUploadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartedUploadStream";
    }
};
var countIsSymbol = {
    reflectSymbol: function () {
        return "count";
    }
};
var showRecordFieldsCons2 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(countIsSymbol);
var intervalIsSymbol = {
    reflectSymbol: function () {
        return "interval";
    }
};
var showRecordFieldsCons3 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(intervalIsSymbol);
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt);
var StartedPingStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartedPingStream";
    }
};
var FinishedPingStreamIsSymbol = {
    reflectSymbol: function () {
        return "FinishedPingStream";
    }
};
var durationIsSymbol = {
    reflectSymbol: function () {
        return "duration";
    }
};
var PerformedPingIsSymbol = {
    reflectSymbol: function () {
        return "PerformedPing";
    }
};
var versionIsSymbol = {
    reflectSymbol: function () {
        return "version";
    }
};
var EngineInfoIsSymbol = {
    reflectSymbol: function () {
        return "EngineInfo";
    }
};
var StartDownloadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartDownloadStream";
    }
};
var StartUploadStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartUploadStream";
    }
};
var StartPingStreamIsSymbol = {
    reflectSymbol: function () {
        return "StartPingStream";
    }
};
var hostIsSymbol = {
    reflectSymbol: function () {
        return "host";
    }
};
var portIsSymbol = {
    reflectSymbol: function () {
        return "port";
    }
};
var StartPingSynIsSymbol = {
    reflectSymbol: function () {
        return "StartPingSyn";
    }
};
var StopStreamIsSymbol = {
    reflectSymbol: function () {
        return "StopStream";
    }
};
var StopStreamsIsSymbol = {
    reflectSymbol: function () {
        return "StopStreams";
    }
};
var HealthCheckIsSymbol = {
    reflectSymbol: function () {
        return "HealthCheck";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Argonaut_Decode_Error.eqJsonDecodeError);
var eq2 = /* #__PURE__ */ Data_Eq.eq(MST_Data_StreamEvent.eqStreamEventBatch);
var eq3 = /* #__PURE__ */ Data_Eq.eq(MST_Data_Units.eqStreamId);
var eq4 = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var eq5 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Bytes.eqBytes);
var eq6 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqInt));
var eq7 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Duration.eqDuration);
var eq8 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Either.eqEither(Data_Eq.eqString)(Fusion_Data_Duration.eqDuration));
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_BasicURL.encodeJsonBasicURL);
var gEncodeJsonCons1 = /* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)(urlIsSymbol)();
var encodeRepArgsArgument = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons1)());
var gEncodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var gEncodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_Units.encodeJsonStreamId);
var gEncodeJsonCons4 = /* #__PURE__ */ gEncodeJsonCons3(Data_Argonaut_Encode_Class.gEncodeJsonNil)(streamIdIsSymbol)();
var encodeRepArgsArgument1 = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons4)());
var gEncodeJsonCons5 = /* #__PURE__ */ gEncodeJsonCons3(gEncodeJsonCons1)(streamIdIsSymbol)();
var gEncodeJsonCons6 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Bytes.encodeJsonBytes);
var gEncodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonInt));
var gEncodeJsonCons8 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Duration.encodeJsonDuration);
var gEncodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_BasicURL.decodeJsonBasicURL));
var gDecodeJsonCons1 = /* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(urlIsSymbol)()();
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons1)();
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_Units.decodeJsonStreamId));
var gDecodeJsonCons4 = /* #__PURE__ */ gDecodeJsonCons3(Data_Argonaut_Decode_Class.gDecodeJsonNil)(streamIdIsSymbol)()();
var decodeRecord1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons4)();
var gDecodeJsonCons5 = /* #__PURE__ */ gDecodeJsonCons3(gDecodeJsonCons1)(streamIdIsSymbol)()();
var gDecodeJsonCons6 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Bytes.decodeJsonBytes));
var gDecodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonInt));
var gDecodeJsonCons8 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Duration.decodeJsonDuration));
var gDecodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt));
var Local = /* #__PURE__ */ (function () {
    function Local() {

    };
    Local.value = new Local();
    return Local;
})();
var Remote = /* #__PURE__ */ (function () {
    function Remote(value0) {
        this.value0 = value0;
    };
    Remote.create = function (value0) {
        return new Remote(value0);
    };
    return Remote;
})();
var InvalidResponse = /* #__PURE__ */ (function () {
    function InvalidResponse(value0) {
        this.value0 = value0;
    };
    InvalidResponse.create = function (value0) {
        return new InvalidResponse(value0);
    };
    return InvalidResponse;
})();
var OtherError = /* #__PURE__ */ (function () {
    function OtherError(value0) {
        this.value0 = value0;
    };
    OtherError.create = function (value0) {
        return new OtherError(value0);
    };
    return OtherError;
})();
var NetworkReport = /* #__PURE__ */ (function () {
    function NetworkReport(value0) {
        this.value0 = value0;
    };
    NetworkReport.create = function (value0) {
        return new NetworkReport(value0);
    };
    return NetworkReport;
})();
var $$Error = /* #__PURE__ */ (function () {
    function $$Error(value0) {
        this.value0 = value0;
    };
    $$Error.create = function (value0) {
        return new $$Error(value0);
    };
    return $$Error;
})();
var Ok = /* #__PURE__ */ (function () {
    function Ok() {

    };
    Ok.value = new Ok();
    return Ok;
})();
var BadCommand = /* #__PURE__ */ (function () {
    function BadCommand(value0) {
        this.value0 = value0;
    };
    BadCommand.create = function (value0) {
        return new BadCommand(value0);
    };
    return BadCommand;
})();
var ConnectionEstablished = /* #__PURE__ */ (function () {
    function ConnectionEstablished() {

    };
    ConnectionEstablished.value = new ConnectionEstablished();
    return ConnectionEstablished;
})();
var StreamNotFound = /* #__PURE__ */ (function () {
    function StreamNotFound(value0) {
        this.value0 = value0;
    };
    StreamNotFound.create = function (value0) {
        return new StreamNotFound(value0);
    };
    return StreamNotFound;
})();
var StartedDownloadStream = /* #__PURE__ */ (function () {
    function StartedDownloadStream(value0) {
        this.value0 = value0;
    };
    StartedDownloadStream.create = function (value0) {
        return new StartedDownloadStream(value0);
    };
    return StartedDownloadStream;
})();
var StartedUploadStream = /* #__PURE__ */ (function () {
    function StartedUploadStream(value0) {
        this.value0 = value0;
    };
    StartedUploadStream.create = function (value0) {
        return new StartedUploadStream(value0);
    };
    return StartedUploadStream;
})();
var StartedPingStream = /* #__PURE__ */ (function () {
    function StartedPingStream(value0) {
        this.value0 = value0;
    };
    StartedPingStream.create = function (value0) {
        return new StartedPingStream(value0);
    };
    return StartedPingStream;
})();
var FinishedPingStream = /* #__PURE__ */ (function () {
    function FinishedPingStream(value0) {
        this.value0 = value0;
    };
    FinishedPingStream.create = function (value0) {
        return new FinishedPingStream(value0);
    };
    return FinishedPingStream;
})();
var PerformedPing = /* #__PURE__ */ (function () {
    function PerformedPing(value0) {
        this.value0 = value0;
    };
    PerformedPing.create = function (value0) {
        return new PerformedPing(value0);
    };
    return PerformedPing;
})();
var EngineInfo = /* #__PURE__ */ (function () {
    function EngineInfo(value0) {
        this.value0 = value0;
    };
    EngineInfo.create = function (value0) {
        return new EngineInfo(value0);
    };
    return EngineInfo;
})();
var Open = /* #__PURE__ */ (function () {
    function Open() {

    };
    Open.value = new Open();
    return Open;
})();
var Close = /* #__PURE__ */ (function () {
    function Close() {

    };
    Close.value = new Close();
    return Close;
})();
var ConnectionFailure = /* #__PURE__ */ (function () {
    function ConnectionFailure(value0) {
        this.value0 = value0;
    };
    ConnectionFailure.create = function (value0) {
        return new ConnectionFailure(value0);
    };
    return ConnectionFailure;
})();
var Message = /* #__PURE__ */ (function () {
    function Message(value0) {
        this.value0 = value0;
    };
    Message.create = function (value0) {
        return new Message(value0);
    };
    return Message;
})();
var StartDownloadStream = /* #__PURE__ */ (function () {
    function StartDownloadStream(value0) {
        this.value0 = value0;
    };
    StartDownloadStream.create = function (value0) {
        return new StartDownloadStream(value0);
    };
    return StartDownloadStream;
})();
var StartUploadStream = /* #__PURE__ */ (function () {
    function StartUploadStream(value0) {
        this.value0 = value0;
    };
    StartUploadStream.create = function (value0) {
        return new StartUploadStream(value0);
    };
    return StartUploadStream;
})();
var StartPingStream = /* #__PURE__ */ (function () {
    function StartPingStream(value0) {
        this.value0 = value0;
    };
    StartPingStream.create = function (value0) {
        return new StartPingStream(value0);
    };
    return StartPingStream;
})();
var StartPingSyn = /* #__PURE__ */ (function () {
    function StartPingSyn(value0) {
        this.value0 = value0;
    };
    StartPingSyn.create = function (value0) {
        return new StartPingSyn(value0);
    };
    return StartPingSyn;
})();
var StopStream = /* #__PURE__ */ (function () {
    function StopStream(value0) {
        this.value0 = value0;
    };
    StopStream.create = function (value0) {
        return new StopStream(value0);
    };
    return StopStream;
})();
var StopStreams = /* #__PURE__ */ (function () {
    function StopStreams() {

    };
    StopStreams.value = new StopStreams();
    return StopStreams;
})();
var HealthCheck = /* #__PURE__ */ (function () {
    function HealthCheck() {

    };
    HealthCheck.value = new HealthCheck();
    return HealthCheck;
})();
var showEngineResponseError = {
    show: function (v) {
        if (v instanceof InvalidResponse) {
            return Data_Argonaut_Decode_Error.printJsonDecodeError(v.value0);
        };
        if (v instanceof OtherError) {
            return v.value0;
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 154, column 1 - line 156, column 30): " + [ v.constructor.name ]);
    }
};
var genericEngineType_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Local.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new Remote(x.value0);
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 163, column 1 - line 163, column 37): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Local) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Remote) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 163, column 1 - line 163, column 37): " + [ x.constructor.name ]);
    }
};
var showEngineType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEngineType_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(LocalIsSymbol))(/* #__PURE__ */ genericShowConstructor1(RemoteIsSymbol)))
};
var genericEngineResponse_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new NetworkReport(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new $$Error(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Ok.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new BadCommand(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return ConnectionEstablished.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new StreamNotFound(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new StartedDownloadStream(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new StartedUploadStream(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new StartedPingStream(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return new FinishedPingStream(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return new PerformedPing(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))) {
            return new EngineInfo(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 141, column 1 - line 141, column 41): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof NetworkReport) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof $$Error) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Ok) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof BadCommand) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof ConnectionEstablished) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof StreamNotFound) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof StartedDownloadStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof StartedUploadStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof StartedPingStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof FinishedPingStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))));
        };
        if (x instanceof PerformedPing) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))));
        };
        if (x instanceof EngineInfo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))))))))));
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 141, column 1 - line 141, column 41): " + [ x.constructor.name ]);
    }
};
var showEngineResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEngineResponse_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(batchIsSymbol)(MST_Data_StreamEvent.showStreamEventBatch))))(NetworkReportIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsConsNil1(Data_Show.showString))))(ErrorIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(OkIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(commandIsSymbol)(Data_Show.showString))))(BadCommandIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ConnectionEstablishedIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(StreamNotFoundIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(showRecordFieldsCons)))(StartedDownloadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(showRecordFieldsCons)(Fusion_Data_Bytes.showBytes))))(StartedUploadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ showRecordFieldsCons3(showRecordFieldsCons)(Fusion_Data_Duration.showDuration))(showMaybe))))(StartedPingStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(FinishedPingStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(durationIsSymbol)(showRecordFieldsConsNil2)(/* #__PURE__ */ Data_Either.showEither(Data_Show.showString)(Fusion_Data_Duration.showDuration)))))(PerformedPingIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(versionIsSymbol)(Data_Show.showString))))(EngineInfoIsSymbol)))))))))))))
};
var genericEngineConnectionEv = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Open.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Close.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ConnectionFailure(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new Message(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 161, column 1 - line 161, column 48): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Open) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Close) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ConnectionFailure) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof Message) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 161, column 1 - line 161, column 48): " + [ x.constructor.name ]);
    }
};
var showEngineConnectionEvent = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEngineConnectionEv)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Open";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Close";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsConsNil1(showEngineResponseError))))({
        reflectSymbol: function () {
            return "ConnectionFailure";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
        reflectSymbol: function () {
            return "message";
        }
    })(showEngineResponse))))({
        reflectSymbol: function () {
            return "Message";
        }
    })))))
};
var genericEngineCommand_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new StartDownloadStream(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new StartUploadStream(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new StartPingStream(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new StartPingSyn(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new StopStream(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return StopStreams.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return HealthCheck.value;
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 140, column 1 - line 140, column 40): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof StartDownloadStream) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof StartUploadStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof StartPingStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof StartPingSyn) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof StopStream) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof StopStreams) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof HealthCheck) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))));
        };
        throw new Error("Failed pattern match at MST.Data.EngineCommunication (line 140, column 1 - line 140, column 40): " + [ x.constructor.name ]);
    }
};
var showEngineCommand = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEngineCommand_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(StartDownloadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons1(showRecordFieldsConsNil)(Fusion_Data_Bytes.showBytes))))(StartUploadStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ showRecordFieldsCons3(showRecordFieldsConsNil)(Fusion_Data_Duration.showDuration))(showMaybe))))(StartPingStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons2(/* #__PURE__ */ Data_Show.showRecordFieldsCons(hostIsSymbol)(/* #__PURE__ */ showRecordFieldsCons3(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(portIsSymbol)(Data_Show.showInt))(Fusion_Data_Duration.showDuration))(MST_Data_BasicURL.showBasicURL))(Data_Show.showInt))))(StartPingSynIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor2(StopStreamIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(StopStreamsIsSymbol))(/* #__PURE__ */ genericShowConstructor(HealthCheckIsSymbol))))))))
};
var eqEngineResponseError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof InvalidResponse && y instanceof InvalidResponse) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof OtherError && y instanceof OtherError) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var eq10 = /* #__PURE__ */ Data_Eq.eq(eqEngineResponseError);
var eqEngineResponse = {
    eq: function (x) {
        return function (y) {
            if (x instanceof NetworkReport && y instanceof NetworkReport) {
                return eq2(x.value0.batch)(y.value0.batch);
            };
            if (x instanceof $$Error && y instanceof $$Error) {
                return x.value0.error === y.value0.error;
            };
            if (x instanceof Ok && y instanceof Ok) {
                return true;
            };
            if (x instanceof BadCommand && y instanceof BadCommand) {
                return x.value0.command === y.value0.command;
            };
            if (x instanceof ConnectionEstablished && y instanceof ConnectionEstablished) {
                return true;
            };
            if (x instanceof StreamNotFound && y instanceof StreamNotFound) {
                return eq3(x.value0.streamId)(y.value0.streamId);
            };
            if (x instanceof StartedDownloadStream && y instanceof StartedDownloadStream) {
                return eq3(x.value0.streamId)(y.value0.streamId) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartedUploadStream && y instanceof StartedUploadStream) {
                return eq5(x.value0.byteCount)(y.value0.byteCount) && eq3(x.value0.streamId)(y.value0.streamId) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartedPingStream && y instanceof StartedPingStream) {
                return eq6(x.value0.count)(y.value0.count) && eq7(x.value0.interval)(y.value0.interval) && eq3(x.value0.streamId)(y.value0.streamId) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof FinishedPingStream && y instanceof FinishedPingStream) {
                return eq3(x.value0.streamId)(y.value0.streamId);
            };
            if (x instanceof PerformedPing && y instanceof PerformedPing) {
                return eq8(x.value0.duration)(y.value0.duration) && eq3(x.value0.streamId)(y.value0.streamId);
            };
            if (x instanceof EngineInfo && y instanceof EngineInfo) {
                return x.value0.version === y.value0.version;
            };
            return false;
        };
    }
};
var eq11 = /* #__PURE__ */ Data_Eq.eq(eqEngineResponse);
var eqEngineConnectionEvent = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Open && y instanceof Open) {
                return true;
            };
            if (x instanceof Close && y instanceof Close) {
                return true;
            };
            if (x instanceof ConnectionFailure && y instanceof ConnectionFailure) {
                return eq10(x.value0.error)(y.value0.error);
            };
            if (x instanceof Message && y instanceof Message) {
                return eq11(x.value0.message)(y.value0.message);
            };
            return false;
        };
    }
};
var eqEngineCommand = {
    eq: function (x) {
        return function (y) {
            if (x instanceof StartDownloadStream && y instanceof StartDownloadStream) {
                return eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartUploadStream && y instanceof StartUploadStream) {
                return eq5(x.value0.byteCount)(y.value0.byteCount) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartPingStream && y instanceof StartPingStream) {
                return eq6(x.value0.count)(y.value0.count) && eq7(x.value0.interval)(y.value0.interval) && eq4(x.value0.url)(y.value0.url);
            };
            if (x instanceof StartPingSyn && y instanceof StartPingSyn) {
                return x.value0.count === y.value0.count && eq4(x.value0.host)(y.value0.host) && eq7(x.value0.interval)(y.value0.interval) && x.value0.port === y.value0.port;
            };
            if (x instanceof StopStream && y instanceof StopStream) {
                return eq3(x.value0.streamId)(y.value0.streamId);
            };
            if (x instanceof StopStreams && y instanceof StopStreams) {
                return true;
            };
            if (x instanceof HealthCheck && y instanceof HealthCheck) {
                return true;
            };
            return false;
        };
    }
};
var encodeJsonEngineType = {
    encodeJson: /* #__PURE__ */ Data_Argonaut_Encode_Generic.genericEncodeJson(genericEngineType_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(LocalIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(RemoteIsSymbol)(encodeRepArgsArgument)))
};
var encodeJsonEngineResponse = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericEngineResponse_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(NetworkReportIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_StreamEvent.encodeJsonStreamEventBatc)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(batchIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ErrorIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(errorIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(OkIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(BadCommandIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(commandIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ConnectionEstablishedIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StreamNotFoundIsSymbol)(encodeRepArgsArgument1))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartedDownloadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons5)())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartedUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons6(gEncodeJsonCons5)(byteCountIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartedPingStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons7(/* #__PURE__ */ gEncodeJsonCons8(gEncodeJsonCons5)(intervalIsSymbol)())(countIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(FinishedPingStreamIsSymbol)(encodeRepArgsArgument1))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(PerformedPingIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonEither(Data_Argonaut_Encode_Class.encodeJsonJString)(Fusion_Data_Duration.encodeJsonDuration))(gEncodeJsonCons4)(durationIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(EngineInfoIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(versionIsSymbol)())()))))))))))))))
};
var encodeJsonEngineCommand = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericEngineCommand_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartDownloadStreamIsSymbol)(encodeRepArgsArgument))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons6(gEncodeJsonCons1)(byteCountIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartPingStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons7(/* #__PURE__ */ gEncodeJsonCons8(gEncodeJsonCons1)(intervalIsSymbol)())(countIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StartPingSynIsSymbol)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons9(Data_Argonaut_Encode_Class.gEncodeJsonNil)(portIsSymbol)())(intervalIsSymbol)())(hostIsSymbol)())(countIsSymbol)())())))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StopStreamIsSymbol)(encodeRepArgsArgument1))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(StopStreamsIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(HealthCheckIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))))))
};
var decodeJsonEngineType = {
    decodeJson: /* #__PURE__ */ Data_Argonaut_Decode_Generic.genericDecodeJson(genericEngineType_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(LocalIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(RemoteIsSymbol)(decodeRecord)))
};
var decodeJsonEngineResponse = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericEngineResponse_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(NetworkReportIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_StreamEvent.decodeJsonStreamEventBatc))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(batchIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(ErrorIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(errorIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(OkIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(BadCommandIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(commandIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(ConnectionEstablishedIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StreamNotFoundIsSymbol)(decodeRecord1))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartedDownloadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons5)()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartedUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons6(gDecodeJsonCons5)(byteCountIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartedPingStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons8(gDecodeJsonCons5)(intervalIsSymbol)()())(countIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(FinishedPingStreamIsSymbol)(decodeRecord1))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(PerformedPingIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonEither(Data_Argonaut_Decode_Class.decodeJsonString)(Fusion_Data_Duration.decodeJsonDuration)))(gDecodeJsonCons4)(durationIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(EngineInfoIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(versionIsSymbol)()())())))))))))))))
};
var decodeJsonEngineCommand = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericEngineCommand_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartDownloadStreamIsSymbol)(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartUploadStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons6(gDecodeJsonCons1)(byteCountIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartPingStreamIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons8(gDecodeJsonCons1)(intervalIsSymbol)()())(countIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StartPingSynIsSymbol)(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons9(Data_Argonaut_Decode_Class.gDecodeJsonNil)(portIsSymbol)()())(intervalIsSymbol)()())(hostIsSymbol)()())(countIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorArg(StopStreamIsSymbol)(decodeRecord1))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(StopStreamsIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(HealthCheckIsSymbol))))))))
};
export {
    StartDownloadStream,
    StartUploadStream,
    StartPingStream,
    StartPingSyn,
    StopStream,
    StopStreams,
    HealthCheck,
    Open,
    Close,
    ConnectionFailure,
    Message,
    NetworkReport,
    $$Error as Error,
    Ok,
    BadCommand,
    ConnectionEstablished,
    StreamNotFound,
    StartedDownloadStream,
    StartedUploadStream,
    StartedPingStream,
    FinishedPingStream,
    PerformedPing,
    EngineInfo,
    InvalidResponse,
    OtherError,
    Local,
    Remote,
    decodeJsonEngineResponse,
    encodeJsonEngineResponse,
    encodeJsonEngineCommand,
    decodeJsonEngineCommand,
    genericEngineCommand_,
    genericEngineResponse_,
    showEngineCommand,
    showEngineResponse,
    eqEngineResponse,
    eqEngineResponseError,
    eqEngineConnectionEvent,
    eqEngineCommand,
    showEngineResponseError,
    showEngineConnectionEvent,
    genericEngineConnectionEv,
    genericEngineType_,
    encodeJsonEngineType,
    decodeJsonEngineType,
    showEngineType
};
